export class ActivitiesValidator {
    public static ACTIVITIES_VALIDATION_MESSAGES = {
        'subject': [
            { type: 'required', message: 'Asunto es requerido' },
            { type: 'minlength', message: 'El asunto no puede tener menos de 3 caracteres' },
            { type: 'maxlength', message: 'El asunto no puede tener más de 80 caracteres' }
        ],
        'content': [
            { type: 'required', message: 'Texto es requerido' },
            { type: 'minlength', message: 'El texto no puede tener menos de 5 caracteres' },
            { type: 'maxlength', message: 'El texto no puede tener más de 250 caracteres' }
        ],
        'date_activity': [
            { type: 'required', message: 'Fecha de la Actividad es requerido' },
        ],
        'hour_activity': [
            { type: 'required', message: 'Hora de la Actividad es requerido' },
        ],
        'idsCollaborators': [
            { type: 'required', message: 'colaboradores es requerido' },
        ],
        'date': []
    }
}